import React, {useState} from "react";
import { SketchPicker } from 'react-color'

const swatch = {
  padding: '5px',
  background: '#fff',
  borderRadius: '1px',
  boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
  display: 'inline-block',
  cursor: 'pointer',  
}

const popover = {
  position: 'absolute',
  zIndex: '2',  
}

const cover = {
  position: 'fixed',
  top: '0px',
  right: '0px',
  bottom: '0px',
  left: '0px',
}

const ColorPickerControl = ({color, handleChange, displayColorPicker, handleClick}) => {
  if(displayColorPicker) {
    return (
      <div style={popover}>
        <div style={ cover } onClick={ handleClick }/>
        <SketchPicker color={ color } onChange={ handleChange } />
      </div>
    )
  }
  
  return null;
}

const ColorPicker = ({color, handleColorChange, tagName, width, height, displayColorPicker, setDisplayColorPicker}) => {
  // const [displayColorPicker, setDisplayColorPicker] = useState(false);  
  // const [defaultColor, setDefaultColor] = useState('#abc');
  
  const handleClick = () => {    
    setDisplayColorPicker(!displayColorPicker);
  }
    
  // const handleClick = () => {    
  //   setDisplayColorPicker(!displayColorPicker);
  // }

  const handleChange = (selectedColor) => {
    // handleColorChange(selectedColor.hex);
    handleColorChange({[tagName]: selectedColor.hex})
  }

  return (
    <div >
      <div style={swatch} onClick={handleClick}>
        <div style={ {
          backgroundColor: color,
          width: width ? width : '36px',
          height: height ? height : '14px',
          borderRadius: '2px'
        } } />
      </div>
      <ColorPickerControl color={color} handleChange={handleChange} displayColorPicker={displayColorPicker} handleClick={handleClick}/>
    </div>
  )
}

export default ColorPicker;